import INVENTORY_API_BASE_URL from "../../config/api";
import React, { useEffect, useState } from "react";
import axios from "axios";
import "./expensedata.css";
import Papa from "papaparse";
import { Player } from "@lottiefiles/react-lottie-player";

function Expensedata() {
  const [expenses, setExpenses] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editedValues, setEditedValues] = useState({});
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [filteredExpenses, setFilteredExpenses] = useState([]);

  useEffect(() => {
    fetchExpenses();
  }, []);

  const fetchExpenses = async () => {
    try {
      const response = await axios.get(
        `${INVENTORY_API_BASE_URL}/expenses`
      );
      setExpenses(response.data);
      setFilteredExpenses(response.data);
    } catch (error) {
      console.error("Error fetching expenses:", error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this expense?")) {
      try {
        await axios.delete(`${INVENTORY_API_BASE_URL}/expenses/${id}`);
        setExpenses(expenses.filter((exp) => exp._id !== id));
      } catch (error) {
        console.error("Error deleting expense:", error);
      }
    }
  };

  const handleEdit = (exp) => {
    setEditingId(exp._id);
    setEditedValues(exp);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let updatedValue = value;

    if (["vendor", "description", "paymentMethod"].includes(name)) {
      updatedValue = capitalizeWords(value);
    }

    setEditedValues({ ...editedValues, [name]: updatedValue });
  };

  const handleCancel = () => {
    setEditingId(null);
    setEditedValues({});
  };

  const handleSave = async () => {
    try {
      const response = await axios.put(
        `${INVENTORY_API_BASE_URL}/expenses/${editingId}`,
        editedValues
      );
      setExpenses(
        expenses.map((exp) => (exp._id === editingId ? response.data : exp))
      );
      setEditingId(null);
      setEditedValues({});
    } catch (error) {
      console.error("Error updating expense:", error);
    }
  };

  const downloadCSV = () => {
    const formattedData = expenses.map((exp) => ({
      Category: exp.category,
      Subcategory: exp.subcategory,
      Vendor: exp.vendor,
      Date: new Date(exp.date).toLocaleDateString(),
      "Expense Type": exp.expenseType,
      Description: exp.description,
      "Payment Method": exp.paymentMethod,
      "Invoice Number": exp.invoiceNumber,
      Amount: exp.amount,
      "Receipt URL": exp.receiptUrl
        ? `https://d6awmbeulqwbq.cloudfront.net${
            new URL(exp.receiptUrl).pathname
          }`
        : "No File",
    }));

    const csv = Papa.unparse(formattedData);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "expenses_data.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleFilter = () => {
    const filtered = expenses.filter((exp) => {
      const expenseDate = new Date(exp.date);
      const start = startDate ? new Date(startDate) : null;
      const end = endDate ? new Date(endDate) : null;

      if (start && end) return expenseDate >= start && expenseDate <= end;
      if (start) return expenseDate >= start;
      if (end) return expenseDate <= end;
      return true;
    });
    setFilteredExpenses(filtered);
  };

  const handleClear = () => {
    setStartDate("");
    setEndDate("");
    setFilteredExpenses(expenses);
  };
  const capitalizeWords = (str) =>
    str.replace(/\b\w/g, (char) => char.toUpperCase());

  return (
    <div className="expensedata-container">
      <h4 style={{ textAlign: "center" }}>All Expenses</h4>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          flexWrap: "nowrap",
          marginBottom: "15px",
          whiteSpace: "nowrap",
        }}
      >
        <button
          onClick={downloadCSV}
          style={{
            padding: "4px 10px",
            backgroundColor: "#007bff",
            color: "#fff",
            fontSize: "12px",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Download CSV
        </button>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
            marginLeft: "16rem",
          }}
        >
          <label style={{ fontSize: "13px" }}>Start:</label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            style={{
              padding: "4px 6px",
              fontSize: "12px",
              borderRadius: "4px",
              border: "1px solid #ccc",
            }}
          />
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <label style={{ fontSize: "13px" }}>End:</label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            style={{
              padding: "4px 6px",
              fontSize: "12px",
              borderRadius: "4px",
              border: "1px solid #ccc",
            }}
          />
        </div>

        <button
          onClick={handleFilter}
          style={{
            padding: "4px 10px",
            backgroundColor: "#198754",
            color: "#fff",
            fontSize: "12px",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Submit
        </button>

        <button
          onClick={handleClear}
          style={{
            padding: "4px 10px",
            backgroundColor: "#6c757d",
            color: "#fff",
            fontSize: "12px",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Clear
        </button>
      </div>

      {filteredExpenses.length === 0 ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "40px",
            color: "#6c757d",
          }}
        >
          <Player
            autoplay
            loop
            src="https://assets10.lottiefiles.com/packages/lf20_qp1q7mct.json"
            style={{ height: "220px", width: "220px" }}
          />
          <p style={{ fontSize: "18px", fontWeight: "600", marginTop: "10px" }}>
            No expense records found
          </p>
        </div>
      ) : (
        <div
          style={{
            overflowX: "auto",
            width: "100%",
            paddingBottom: "10px",
          }}
        >
          <table
            style={{
              minWidth: "1400px",
              width: "100%",
              borderCollapse: "collapse",
              textAlign: "center",
              marginTop: "20px",
              borderRadius: "12px",
              overflow: "hidden",
              fontFamily: "Arial, sans-serif",
              fontSize: "14px",
            }}
            border="1"
            cellPadding="10"
            cellSpacing="0"
          >
            <thead style={{ backgroundColor: "#f1f3f5" }}>
              <tr>
                {[
                  "Category",
                  "Subcategory",
                  "Vendor Name",
                  "Date",
                  "Expense Type",
                  "Description",
                  "Payment Method",
                  "Invoice Number",
                  "Amount",
                  "Receipt",
                  "Edit",
                  "Delete",
                ].map((header) => (
                  <th
                    key={header}
                    style={{
                      padding: "10px 8px",
                      fontWeight: "bold",
                      backgroundColor: "#dee2e6",
                      border: "1px solid #ced4da",
                      whiteSpace: "nowrap",
                      textAlign: "center",
                    }}
                  >
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredExpenses.map((exp) => {
                const isEditing = editingId === exp._id;
                return (
                  <tr key={exp._id} style={{ backgroundColor: "#ffffff" }}>
                    {isEditing ? (
                      <>
                        {[
                          "category",
                          "subcategory",
                          "vendor",
                          "expenseType",
                          "description",
                          "paymentMethod",
                          "invoiceNumber",
                          "amount",
                        ].map((field) => (
                          <td
                            key={field}
                            style={{
                              whiteSpace: "nowrap",
                              textAlign: "center",
                            }}
                          >
                            <input
                              type={field === "amount" ? "number" : "text"}
                              name={field}
                              value={editedValues[field] || ""}
                              onChange={handleInputChange}
                              style={{
                                width: "130px",
                                padding: "6px 8px",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                textAlign: "center",
                              }}
                            />
                          </td>
                        ))}
                        <td style={{ textAlign: "center" }}>
                          <input
                            type="date"
                            name="date"
                            value={
                              editedValues.date
                                ? editedValues.date.slice(0, 10)
                                : ""
                            }
                            onChange={handleInputChange}
                            style={{
                              width: "140px",
                              padding: "6px 8px",
                              border: "1px solid #ccc",
                              borderRadius: "4px",
                              textAlign: "center",
                            }}
                          />
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {exp.receiptUrl ? (
                            <a
                              href={`https://d6awmbeulqwbq.cloudfront.net${
                                new URL(exp.receiptUrl).pathname
                              }`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                color: "#0d6efd",
                                textDecoration: "none",
                              }}
                            >
                              View Receipt
                            </a>
                          ) : (
                            "No File"
                          )}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          <button
                            onClick={handleSave}
                            style={{
                              padding: "5px 10px",
                              backgroundColor: "#28a745",
                              color: "#fff",
                              border: "none",
                              borderRadius: "4px",
                              marginRight: "5px",
                            }}
                          >
                            Save
                          </button>
                          <button
                            onClick={handleCancel}
                            style={{
                              padding: "5px 10px",
                              backgroundColor: "#6c757d",
                              color: "#fff",
                              border: "none",
                              borderRadius: "4px",
                            }}
                          >
                            Cancel
                          </button>
                        </td>
                      </>
                    ) : (
                      <>
                        <td style={{ textAlign: "center" }}>{exp.category}</td>
                        <td style={{ textAlign: "center" }}>
                          {exp.subcategory}
                        </td>
                        <td style={{ textAlign: "center" }}>{exp.vendor}</td>
                        <td style={{ textAlign: "center" }}>
                          {new Date(exp.date).toLocaleDateString()}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {exp.expenseType}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {exp.description}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {exp.paymentMethod}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {exp.invoiceNumber}
                        </td>
                        <td style={{ textAlign: "center" }}>{exp.amount}</td>
                        <td style={{ textAlign: "center" }}>
                          {exp.receiptUrl ? (
                            <a
                              href={`https://d6awmbeulqwbq.cloudfront.net${
                                new URL(exp.receiptUrl).pathname
                              }`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                color: "#0d6efd",
                                textDecoration: "none",
                              }}
                            >
                              View Receipt
                            </a>
                          ) : (
                            "No File"
                          )}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          <button
                            onClick={() => handleEdit(exp)}
                            style={{
                              padding: "5px 10px",
                              backgroundColor: "#ffc107",
                              border: "none",
                              color: "#212529",
                              borderRadius: "4px",
                            }}
                          >
                            Edit
                          </button>
                        </td>
                      </>
                    )}
                    <td style={{ textAlign: "center" }}>
                      <button
                        onClick={() => handleDelete(exp._id)}
                        style={{
                          padding: "5px 10px",
                          backgroundColor: "#dc3545",
                          color: "#fff",
                          border: "none",
                          borderRadius: "4px",
                        }}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default Expensedata;
